<div class="calendar-container">
    <div *ngIf="isLoading" class="calendar-loading-overlay">
        <div class="spinner"></div>
        <p class="loading-text">Loading events...</p>
    </div>

    <div class="calendar-header-wrapper">
        <div class="calendar-nav">
            <button class="nav-btn" (click)="navigateDate('prev')" [disabled]="isLoading">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>

            <div class="date-picker-container">
                <app-input type="date" [(ngModel)]="selectedDate" (ngModelChange)="onDateChange($event)" [disableWeekends]="true"></app-input>
            </div>

            <button class="nav-btn" (click)="navigateDate('next')" [disabled]="isLoading">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>

            <button class="today-btn" (click)="goToToday()" [disabled]="isLoading">Today</button>
        </div>

        <div class="calendar-view-options">
            <button class="view-btn" [class.active]="currentView === 'dayGridMonth'"
                (click)="changeView('dayGridMonth')" [disabled]="isLoading">
                Month
            </button>
            <button class="view-btn" [class.active]="currentView === 'timeGridWeek'"
                (click)="changeView('timeGridWeek')" [disabled]="isLoading">
                Week
            </button>
            <button class="view-btn" [class.active]="currentView === 'timeGridDay'" (click)="changeView('timeGridDay')"
                [disabled]="isLoading">
                Day
            </button>
        </div>
    </div>

    <div class="calendar-wrapper" [class.loading]="isLoading">
        <full-calendar #calendar [options]="calendarOptions"></full-calendar>
    </div>

    <div class="modal-overlay" *ngIf="showEventModal" (click)="closeEventModal()">
        <div class="modal-content" [style.backgroundColor]="hexToRgba(selectedEvent.color,1)"
            (click)="$event.stopPropagation()">
            <div class="modal-header">
                <p [style.backgroundColor]="selectedEvent.color" [style.color]="selectedEvent.borderColor">
                    <span [style.backgroundColor]="selectedEvent.borderColor"></span> {{ selectedEvent.status }}
                </p>
                <button class="close-btn" (click)="closeEventModal()">&times;</button>
            </div>
            <div class="modal-body" *ngIf="selectedEvent">
                <h2 class="title">{{ selectedEvent.title }}</h2>
                <div class="info">
                    <div class="colum_row">
                        <div class="rows">
                            <span class="icon">📅</span>
                            <div>
                                <div class="label">START</div>
                                <div class="value">{{formatDate(selectedEvent.startDate)}}</div>
                            </div>
                        </div>
                        <div class="rows">
                            <span class="icon">📅</span>
                            <div>
                                <div class="label">END</div>
                                <div class="value">{{ formatDate(selectedEvent.endDate) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="colum_row">
                        <div class="rows" *ngIf="selectedEvent.eventTime">
                            <span class="icon">⏱️</span>
                            <div>
                                <div class="label">TIME</div>
                                <div class="value">{{ selectedEvent.eventTime }}</div>
                            </div>
                        </div>
                        <div class="rows">
                            <span class="icon">📍</span>
                            <div>
                                <div class="label">LOCATION</div>
                                <div class="value">{{ selectedEvent.location }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" (click)="viewEvent()">View event</button>
            </div>
        </div>
    </div>
</div>